import { render, staticRenderFns } from "./CustomSelectComponent.vue?vue&type=template&id=280743cb"
import script from "./CustomSelectComponent.vue?vue&type=script&lang=js"
export * from "./CustomSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports